import React, { useEffect, useState } from 'react';

/**
 * RegalienOzet: Régalien Eylül 2026 performans özeti, 3 slayt (Woo sipariş, GA4 oturum, harcama).
 * Route: /r/regalien-ozet (sidebar YOK, tam ekran slayt).
 * Yeniden üretmek için: node src/pages/regalien-ozet/build.js (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ~34KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function RegalienOzet() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./regalienOzetHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Régalien · Performans Özeti"
      srcDoc={html}
      style={fill}
    />
  );
}
